import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ArgumentTreeType } from "#/entities/argument/model/types";
import { type TreeNodeData } from "#/entities/dataStructures/node/model/nodeSlice";
import { editorSlice, selectIsEditingNodes } from "#/features/treeViewer/model/editorSlice";
import { NodeBase } from "#/features/treeViewer/ui/NodeBase";
import { useNodeColors } from "#/shared/hooks";
import { useAppDispatch, useAppSelector } from "#/store/hooks";
export type GraphNodeProps = TreeNodeData & {
  treeName: string;
  type: ArgumentTreeType;
};
export const GraphNode: React.FC<GraphNodeProps> = t0 => {
  const $ = _c(17);
  let animation;
  let animationCount;
  let color;
  let props;
  if ($[0] !== t0) {
    ({
      color,
      animation,
      animationCount,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = animation;
    $[2] = animationCount;
    $[3] = color;
    $[4] = props;
  } else {
    animation = $[1];
    animationCount = $[2];
    color = $[3];
    props = $[4];
  }
  const dispatch = useAppDispatch();
  const isEditingNodes = useAppSelector(selectIsEditingNodes);
  const {
    nodeColor,
    shadowColor
  } = useNodeColors(color);
  let t1;
  if ($[5] !== dispatch || $[6] !== isEditingNodes || $[7] !== props) {
    t1 = ev => {
      if (!isEditingNodes) {
        return;
      }
      ev.stopPropagation();
      dispatch(editorSlice.actions.startDrag({
        treeName: props.treeName,
        nodeId: props.id,
        startX: props.x,
        startY: props.y,
        startClientX: ev.clientX,
        startClientY: ev.clientY
      }));
    };
    $[5] = dispatch;
    $[6] = isEditingNodes;
    $[7] = props;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const handleMouseDown = t1;
  const t2 = isEditingNodes ? "grab" : "pointer";
  const t3 = isEditingNodes ? "pulse" : animation;
  const t4 = isEditingNodes ? 1 : animationCount;
  let t5;
  if ($[9] !== handleMouseDown || $[10] !== nodeColor || $[11] !== props || $[12] !== shadowColor || $[13] !== t2 || $[14] !== t3 || $[15] !== t4) {
    t5 = <NodeBase nodeColor={nodeColor} shadowColor={shadowColor} onMouseDown={handleMouseDown} cursor={t2} animation={t3} animationCount={t4} {...props} />;
    $[9] = handleMouseDown;
    $[10] = nodeColor;
    $[11] = props;
    $[12] = shadowColor;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};